import { type Locale, type NamespacedMessages } from '@mentimeter/i18n-core';
import deDE from './de-DE.json' with { type: 'json' };
import en from './en.json' with { type: 'json' };
import esES from './es-ES.json' with { type: 'json' };
import ptBR from './pt-BR.json' with { type: 'json' };

const ROOT_KEY = 'ragnar' as const;
type RootKey = typeof ROOT_KEY;

const defaultLanguage: NamespacedMessages<RootKey> = en;

export const messages: NamespacedMessages<Locale> = {
  'de-DE': deDE,
  en: defaultLanguage,
  'es-ES': esES,
  'pt-BR': ptBR,
};
